export default __webpack_public_path__ + "static/public-bookings-a82cf0b85e586b934cbd79712c6987d9.webp";